import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Select, Col, Row, Table, Button } from "antd";
import Cookies from "js-cookie";
import axios from "axios";
import * as XLSX from 'xlsx';
import backButton from '../../assets/images/back_button_arrow.svg';
// import demandIcon from '../../assets/images/icons/demand_icon.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import TooltipIcon from '../../assets/newlayout/tooltip_icon.svg';
// import CSVIcon from '../../assets/newlayout/csv_icon.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import configData from "../../config/config.json";
import { notifysuccess } from "../../utils/toast";
import zoneIcon from '../../assets/images/icons/zone.svg';
import { notifyfailure } from "../../utils/toast";
import CSVIcon from '../../assets/images/icons/offcanva_file_icon.svg';
import { saveAs } from "file-saver";
import BlockCategoryTable from '../BlockCategoryTable';

// ─── Constants ────────────────────────────────────────────────────────────────

const ZONE_TYPES = [
    { label: "Prebid", value: "Prebid" },
    { label: "Open RTB", value: "Open RTB" },
    { label: "Vast Publica", value: "publica" },
    { label: "Vast Adkernel", value: "Vast Zone" },
];

const ZONE_CONFIG = {
    "Prebid": {
        displayName: "Prebid",
        description: "Download the Excel template for Prebid zone type. The template includes required column headers and examples.",
        zoneNameKey: "Zone Name *",
        mandatoryUiCols: [
            ["Traffic Type", "Format Type", "In-Banner Video Allow (Only for Banner Format Type)", "Zone Name (Unique identifier)", "Is Zone Active", "Rev Share", "Min eCPM (Mandatory if Use the highest bid floor is TRUE)", "Human IVT Sampling", /* PIXALATE SUNSET: "Pixalate IVT Sampling", */ "DoubleVerify IVT Sampling"],
        ],
        templateColumns: [
            "Traffic Type *",
            "Format Type *",
            "In Banner Video Allow * (Only for Banner Format Type)",
            "Zone Name *",
            "Is Zone Active? *",
            "Rev Share *",
            "Min eCPM(Mandatory if Use the highest bid floor is TRUE)",
            "Max eCPM",
            "Use the highest bid floor(If True, do provide Min eCPM value)",
            "Requests per Day",
            "Impressions per Day",
            "Human IVT Sampling*",
            // PIXALATE SUNSET: column removed from upload sheet
            // "Pixalate IVT Sampling*",
            "DoubleVerify IVT Sampling*",
            "Pass Inventory Partner Domain",
            "Inventory Partner Domain",
        ],
        // base mandatory (In Banner Video Allow handled conditionally)
        mandatoryKeys: ["Traffic Type *", "Format Type *", "Zone Name *", "Is Zone Active? *", "Rev Share *", "Human IVT Sampling*", /* PIXALATE SUNSET: "Pixalate IVT Sampling*", */ "DoubleVerify IVT Sampling*"],
    },
    "Open RTB": {
        displayName: "Open RTB",
        description: "Download the Excel template for Open RTB zone type. The template includes required column headers and examples.",
        zoneNameKey: "Zone Name *",
        mandatoryUiCols: [
            ["Traffic Type", "Format Type", "In-Banner Video Allow (Only for Banner Format Type)", "Zone Name (Unique identifier)", "Is Zone Active", "Integration Type", "Rev Share", "Min eCPM (Mandatory if Use the highest bid floor is TRUE)", "Human IVT Sampling", /* PIXALATE SUNSET: "Pixalate IVT Sampling", */ "DoubleVerify IVT Sampling"],
        ],
        templateColumns: [
            "Traffic Type *",
            "Format Type *",
            "In Banner Video Allow * (Only for Banner Format Type)",
            "Zone Name *",
            "Is Zone Active?*",
            "Integration Type *",
            "Rev Share *",
            "Min eCPM (Mandatory if Use the highest bid floor is TRUE)",
            "Max eCPM",
            "Use the highest bid floor (If True, do provide Min eCPM value)",
            "Requests per Day",
            "Impressions per Day",
            "Human IVT Sampling*",
            // PIXALATE SUNSET: column removed from upload sheet
            // "Pixalate IVT Sampling*",
            "DoubleVerify IVT Sampling*",
            "Pass Inventory Partner Domain",
            "Inventory Partner Domain",
        ],
        mandatoryKeys: ["Traffic Type *", "Format Type *", "Zone Name *", "Is Zone Active?*", "Integration Type *", "Rev Share *", "Human IVT Sampling*", /* PIXALATE SUNSET: "Pixalate IVT Sampling*", */ "DoubleVerify IVT Sampling*"],
    },
    "Vast Zone": {
        displayName: "Vast Adkernel",
        description: "Download the Excel template for Vast Adkernel zone type. The template includes required column headers and examples.",
        zoneNameKey: "Zone Name *",
        mandatoryUiCols: [
            ["Traffic Type", "Stream Position", "Zone Name", "Is Zone Active?", "eCPM", "Human IVT Sampling", /* PIXALATE SUNSET: "Pixalate IVT Sampling", */ "DoubleVerify IVT Sampling", "Template"],
        ],
        templateColumns: [
            "Traffic Type *",
            "Stream Position * (For Traffic Type CTV, the value should only by Instream)",
            "Zone Name *",
            "Is Zone Active?*",
            "eCpm*",
            "Requests per Day",
            "Impressions per Day",
            "Human IVT Sampling*",
            // PIXALATE SUNSET: column removed from upload sheet
            // "Pixalate IVT Sampling*",
            "DoubleVerify IVT Sampling*",
            "Pass Inventory Partner Domain",
            "Inventory Partner Domain",
            "Template *",
        ],
        mandatoryKeys: ["Traffic Type *", "Stream Position * (For Traffic Type CTV, the value should only by Instream)", "Zone Name *", "Is Zone Active?*", "eCpm*", "Human IVT Sampling*", /* PIXALATE SUNSET: "Pixalate IVT Sampling*", */ "DoubleVerify IVT Sampling*", "Template *"],
    },
    "publica": {
        displayName: "Vast Publica",
        description: "Download the Excel template for Vast Publica zone type. The template includes required column headers and examples.",
        zoneNameKey: "Channel Name *",
        mandatoryUiCols: [
            ["Traffic Type", "Format Type", "Header Bidder Vast Version", "Channel Name", "Region", "eCPM", "Bid Adjustment", "Template"],
            // ["Region", "eCPM", "Bid Adjustment", "Template"],
        ],
        templateColumns: [
            "Traffic Type *",
            "Format Type *",
            "Header Bidder Vast Version *",
            "Channel Name *",
            "Region *",
            "eCPM *",
            "Bid Adjustment *(Please drag the formula once eCPM entered)",
            "Bid Adjustment Value",
            "Template *",
            "Add value only if obj. empty in bid request",
            "Override",
        ],
        mandatoryKeys: ["Traffic Type *", "Format Type *", "Header Bidder Vast Version *", "Channel Name *", "Region *", "eCPM *", "Bid Adjustment *(Please drag the formula once eCPM entered)", "Template *"],
    },
};

// ─── Column key maps (match templateColumns exactly, fuzzy-remapped at parse time) ──────────────

// Prebid
const PB = {
    trafficType: "Traffic Type *",
    formatType: "Format Type *",
    inBannerVideo: "In Banner Video Allow * (Only for Banner Format Type)",
    zoneName: "Zone Name *",
    isActive: "Is Zone Active? *",
    revShare: "Rev Share *",
    minEcpm: "Min eCPM(Mandatory if Use the highest bid floor is TRUE)",
    maxEcpm: "Max eCPM",
    highestBidFloor: "Use the highest bid floor(If True, do provide Min eCPM value)",
    requestsPerDay: "Requests per Day",
    impressionsPerDay: "Impressions per Day",
    humanIvt: "Human IVT Sampling*",
    // PIXALATE SUNSET: column removed from upload sheet
    // pixalateIvt: "Pixalate IVT Sampling*",
    doubleverifyIvt: "DoubleVerify IVT Sampling*",
    ipdBool: "Pass Inventory Partner Domain",
    ipdValue: "Inventory Partner Domain",
};

// Open RTB
const OR = {
    trafficType: "Traffic Type *",
    formatType: "Format Type *",
    inBannerVideo: "In Banner Video Allow * (Only for Banner Format Type)",
    zoneName: "Zone Name *",
    isActive: "Is Zone Active?*",
    integrationType: "Integration Type *",
    revShare: "Rev Share *",
    minEcpm: "Min eCPM (Mandatory if Use the highest bid floor is TRUE)",
    maxEcpm: "Max eCPM",
    highestBidFloor: "Use the highest bid floor (If True, do provide Min eCPM value)",
    requestsPerDay: "Requests per Day",
    impressionsPerDay: "Impressions per Day",
    humanIvt: "Human IVT Sampling*",
    // PIXALATE SUNSET: column removed from upload sheet
    // pixalateIvt: "Pixalate IVT Sampling*",
    doubleverifyIvt: "DoubleVerify IVT Sampling*",
    ipdBool: "Pass Inventory Partner Domain",
    ipdValue: "Inventory Partner Domain",
};

// Vast (ADK)
const VA = {
    trafficType: "Traffic Type *",
    streamPosition: "Stream Position * (For Traffic Type CTV, the value should only by Instream)",
    zoneName: "Zone Name *",
    isActive: "Is Zone Active?*",
    ecpm: "eCpm*",
    requestsPerDay: "Requests per Day",
    impressionsPerDay: "Impressions per Day",
    humanIvt: "Human IVT Sampling*",
    // PIXALATE SUNSET: column removed from upload sheet
    // pixalateIvt: "Pixalate IVT Sampling*",
    doubleverifyIvt: "DoubleVerify IVT Sampling*",
    ipdBool: "Pass Inventory Partner Domain",
    ipdValue: "Inventory Partner Domain",
    template: "Template *",
};

// Publica
const PC = {
    trafficType: "Traffic Type *",
    formatType: "Format Type *",
    headerBidderVastVersion: "Header Bidder Vast Version *",
    channelName: "Channel Name *",
    region: "Region *",
    ecpm: "eCPM *",
    bidAdjustment: "Bid Adjustment *(Please drag the formula once eCPM entered)",
    bidAdjustmentValue: "Bid Adjustment Value",
    // asi: "ASI *",
    // sid: "SID (Publisher ID) *",
    // name: "Name *",
    // domain: "Domain *",
    template: "Template *",
    addValueIfEmpty: "Add value only if obj. empty in bid request",
    override: "Override",
};

const VALID_TRAFFIC_TYPES = ["website", "inapp"];
const VALID_TRAFFIC_TYPES_OR = ["website", "inapp", "ctv"];
const VALID_FORMAT_TYPES = ["banner", "video", "native"];
const TRUE_FALSE = ["true", "false"];
// Maps normalised label (lowercase) → API value sent in payload
const INTEGRATION_TYPE_MAP_OR = {
    "openrtb": "OPEN_RTB",
    "openrtb w/o nurl": "OPEN_RTB_WO_NURL",
    "openrtb nurl only": "OPEN_RTB_NURL_ONLY",
    "bidswitch": "BIDSWITCH",
    "rubicon": "RUBICON",
    "pubmatic": "PUBMATIC",
    "transsion": "TRANSSION",
    "exoclick": "EXOCLICK",
    "airpush": "AIRPUSH",
    "samsung": "SAMSUNG",
    "vivo": "VIVO",
    "yandex": "YANDEX",
    "oppo": "OPPO",
    "openx": "OPEN_X",
    "xiaomi": "XIAOMI",
    "mobility ware": "MOBILITY_WARE",
    "xiaomi (burl)": "XIAOMI_BURL",
    "traffic junky": "TRAFFIC_JUNKY",
    "chartboost": "CHARTBOOST",
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

const isMissing = (val) => val === "" || val === undefined || val === null;
const normalise = (v) => String(v ?? "").trim().toLowerCase();
// Normalize a header for fuzzy matching: strip *, collapse whitespace, lowercase
const normaliseHeader = (h) => String(h).replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};

// ─── Prebid: validate all rows → { results, payloads } ───────────────────────
function validatePrebidRows(rows, _publisherName, publisherId) {
    // Two-pass duplicate zone name detection
    const zoneNameCount = new Map();
    rows.forEach((row) => {
        const name = String(row[PB.zoneName] ?? "").trim().toLowerCase();
        if (name) zoneNameCount.set(name, (zoneNameCount.get(name) || 0) + 1);
    });
    const duplicateNames = new Set(
        [...zoneNameCount.entries()].filter(([, count]) => count > 1).map(([name]) => name)
    );
    const firstSeenDuplicates = new Set();

    const payloads = [];
    const results = rows.map((row, idx) => {
        const rowNum = idx + 2;
        const zoneNameRaw = String(row[PB.zoneName] ?? "").trim();
        const zoneName = zoneNameRaw || "-";
        const lowerName = zoneNameRaw.toLowerCase();
        const errors = [];

        // Duplicate zone name
        if (lowerName && duplicateNames.has(lowerName)) {
            if (firstSeenDuplicates.has(lowerName)) {
                errors.push("Duplicate zone name");
            } else {
                firstSeenDuplicates.add(lowerName);
            }
        }

        // Traffic Type
        const trafficRaw = String(row[PB.trafficType] ?? "").trim();
        if (isMissing(trafficRaw) || trafficRaw === "") {
            errors.push("Traffic Type is required");
        } else if (!VALID_TRAFFIC_TYPES.includes(normalise(trafficRaw))) {
            errors.push("Traffic Type must be 'Website' or 'Inapp'");
        }

        // Format Type
        const formatRaw = String(row[PB.formatType] ?? "").trim();
        if (isMissing(formatRaw) || formatRaw === "") {
            errors.push("Format Type is required");
        } else if (!VALID_FORMAT_TYPES.includes(normalise(formatRaw))) {
            errors.push("Format Type must be 'Banner', 'Video' or 'Native'");
        }

        // In Banner Video Allow – mandatory only when Format Type is Banner
        const formatIsValid = VALID_FORMAT_TYPES.includes(normalise(formatRaw));
        const isBanner = formatIsValid && normalise(formatRaw) === "banner";
        const inBannerRaw = String(row[PB.inBannerVideo] ?? "").trim();
        if (isBanner) {
            if (inBannerRaw === "") {
                errors.push("In Banner Video Allow is required for Banner format");
            } else if (!["yes", "no"].includes(normalise(inBannerRaw))) {
                errors.push("In Banner Video Allow must be 'Yes' or 'No'");
            }
        } else if (!isBanner && normalise(inBannerRaw) === "yes") {
            errors.push("In Banner Video Allow can only be 'Yes' for Banner format type");
        }

        // Zone Name
        if (isMissing(zoneNameRaw) || zoneNameRaw === "") {
            errors.push("Zone Name is required");
        }

        // Is Zone Active (mandatory, True/False)
        const isActiveRaw = String(row[PB.isActive] ?? "").trim();
        if (isActiveRaw === "") {
            errors.push("Is Zone Active is required");
        } else if (!TRUE_FALSE.includes(normalise(isActiveRaw))) {
            errors.push("Is Zone Active must be 'True' or 'False'");
        }

        // Rev Share
        const revShareRaw = String(row[PB.revShare] ?? "").trim();
        if (isMissing(revShareRaw) || revShareRaw === "") {
            errors.push("Rev Share is required");
        } else {
            const rev = parseFloat(revShareRaw);
            if (isNaN(rev) || rev < 0.1 || rev > 100) {
                errors.push("Rev Share must be between 0.1 and 100");
            }
        }

        // Use the highest bid floor (optional – if True, Min eCPM is required)
        const hbfRaw = String(row[PB.highestBidFloor] ?? "").trim();
        const hbfIsTrue = normalise(hbfRaw) === "true";
        if (hbfRaw !== "" && !TRUE_FALSE.includes(normalise(hbfRaw))) {
            errors.push("Use the highest bid floor must be 'True' or 'False'");
        }

        // Min eCPM – mandatory when highest bid floor is True, optional otherwise
        const minEcpmRaw = String(row[PB.minEcpm] ?? "").trim();
        let minEcpmVal = null;
        if (hbfIsTrue && minEcpmRaw === "") {
            errors.push("Min eCPM is required when Use the highest bid floor is True");
        } else if (minEcpmRaw !== "") {
            const val = parseFloat(minEcpmRaw);
            if (isNaN(val) || val < 0.00001 || val > 50) {
                errors.push("Min eCPM must be between 0.00001 and 50");
            } else {
                minEcpmVal = val;
            }
        }

        // Max eCPM (optional)
        const maxEcpmRaw = String(row[PB.maxEcpm] ?? "").trim();
        let maxEcpmVal = null;
        if (maxEcpmRaw !== "") {
            const val = parseFloat(maxEcpmRaw);
            if (isNaN(val) || val < 0.00001 || val > 50) {
                errors.push("Max eCPM must be between 0.00001 and 50");
            } else {
                maxEcpmVal = val;
            }
        }

        // Min ≤ Max
        if (minEcpmVal !== null && maxEcpmVal !== null && minEcpmVal > maxEcpmVal) {
            errors.push("Min eCPM must be less than or equal to Max eCPM");
        }

        // Requests per Day (optional, integer > 0)
        const reqRaw = String(row[PB.requestsPerDay] ?? "").trim();
        if (reqRaw !== "") {
            const val = Number(reqRaw);
            if (!Number.isInteger(val) || val <= 0) {
                errors.push("Requests per Day must be an integer greater than 0");
            }
        }

        // Impressions per Day (optional, integer > 0)
        const impRaw = String(row[PB.impressionsPerDay] ?? "").trim();
        if (impRaw !== "") {
            const val = Number(impRaw);
            if (!Number.isInteger(val) || val <= 0) {
                errors.push("Impressions per Day must be an integer greater than 0");
            }
        }

        // Human IVT Sampling (mandatory, integer 0–100)
        const humanIvtRaw = String(row[PB.humanIvt] ?? "").trim();
        if (humanIvtRaw === "") {
            errors.push("Human IVT Sampling is required");
        } else {
            const val = Number(humanIvtRaw);
            if (!Number.isInteger(val) || val < 0 || val > 100) {
                errors.push("Human IVT Sampling must be an integer between 0 and 100");
            }
        }

        // PIXALATE SUNSET: Pixalate IVT Sampling column removed from upload sheet.
        /*
        // Pixalate IVT Sampling (mandatory, integer 0–100)
        const pixalateIvtRaw = String(row[PB.pixalateIvt] ?? "").trim();
        if (pixalateIvtRaw === "") {
            errors.push("Pixalate IVT Sampling is required");
        } else {
            const val = Number(pixalateIvtRaw);
            if (!Number.isInteger(val) || val < 0 || val > 100) {
                errors.push("Pixalate IVT Sampling must be an integer between 0 and 100");
            }
        }
        */

        // DoubleVerify IVT Sampling (mandatory, integer 0–100)
        const doubleverifyIvtRaw_pb = String(row[PB.doubleverifyIvt] ?? "").trim();
        if (doubleverifyIvtRaw_pb === "") {
            errors.push("DoubleVerify IVT Sampling is required");
        } else {
            const val = Number(doubleverifyIvtRaw_pb);
            if (!Number.isInteger(val) || val < 0 || val > 100) {
                errors.push("DoubleVerify IVT Sampling must be an integer between 0 and 100");
            }
        }

        // Pass Inventory Partner Domain (optional; must be empty or "TRUE")
        const ipdBoolRaw_pb = String(row[PB.ipdBool] ?? "").trim();
        if (ipdBoolRaw_pb !== "" && normalise(ipdBoolRaw_pb) !== "true") {
            errors.push("Pass Inventory Partner Domain must be empty or 'TRUE'");
        }
        const ipdValueRaw_pb = String(row[PB.ipdValue] ?? "").trim();

        if (errors.length > 0) {
            return { key: String(idx), row: rowNum, zoneName, status: "error", message: errors, _raw: row, _payload: null };
        }

        // Build payload
        const payload = {
            invent_type: trafficRaw,
            exchange_type: "OPEN_RTB",
            traffic_type: formatRaw,
            name: zoneNameRaw,
            is_active: normalise(isActiveRaw) === "true",
            impressions_daily: impRaw !== "" ? parseInt(impRaw, 10) : null,
            requests_daily: reqRaw !== "" ? parseInt(reqRaw, 10) : null,
            publisherId,
            revshare: parseFloat(revShareRaw),
            minEcpm: minEcpmVal,
            maxEcpm: maxEcpmVal,
            isHighestBidFloor: normalise(hbfRaw) === "true",
            bannerCheckbox: isBanner ? normalise(inBannerRaw) === "yes" : null,
            sampling_human: parseInt(humanIvtRaw, 10),
            // PIXALATE SUNSET: not sent in payload
            // sampling_pixalate: parseInt(pixalateIvtRaw, 10),
            sampling_dv: parseInt(doubleverifyIvtRaw_pb, 10),
        };
        if (normalise(ipdBoolRaw_pb) === "true") payload.ipd_bool = true;
        if (ipdValueRaw_pb !== "") payload.ipd_value = ipdValueRaw_pb;
        payloads.push(payload);
        return { key: String(idx), row: rowNum, zoneName, status: "valid", message: "Valid", _raw: row, _payload: payload };
    });

    return { results, payloads };
}

// ─── Open RTB: validate all rows → { results, payloads } ─────────────────────
function validateOpenRTBRows(rows, _publisherName, publisherId) {
    // Two-pass duplicate zone name detection
    const zoneNameCount = new Map();
    rows.forEach((row) => {
        const name = String(row[OR.zoneName] ?? "").trim().toLowerCase();
        if (name) zoneNameCount.set(name, (zoneNameCount.get(name) || 0) + 1);
    });
    const duplicateNames = new Set(
        [...zoneNameCount.entries()].filter(([, count]) => count > 1).map(([name]) => name)
    );
    const firstSeenDuplicates = new Set();

    const payloads = [];
    const results = rows.map((row, idx) => {
        const rowNum = idx + 2;
        const zoneNameRaw = String(row[OR.zoneName] ?? "").trim();
        const zoneName = zoneNameRaw || "-";
        const lowerName = zoneNameRaw.toLowerCase();
        const errors = [];

        // Duplicate zone name
        if (lowerName && duplicateNames.has(lowerName)) {
            if (firstSeenDuplicates.has(lowerName)) {
                errors.push("Duplicate zone name");
            } else {
                firstSeenDuplicates.add(lowerName);
            }
        }

        // Traffic Type
        const trafficRaw = String(row[OR.trafficType] ?? "").trim();
        const isCTV = normalise(trafficRaw) === "ctv";
        if (isMissing(trafficRaw) || trafficRaw === "") {
            errors.push("Traffic Type is required");
        } else if (!VALID_TRAFFIC_TYPES_OR.includes(normalise(trafficRaw))) {
            errors.push("Traffic Type must be 'Website', 'Inapp' or 'CTV'");
        }

        // Format Type
        const formatRaw = String(row[OR.formatType] ?? "").trim();
        if (isMissing(formatRaw) || formatRaw === "") {
            errors.push("Format Type is required");
        } else if (isCTV && normalise(formatRaw) !== "video") {
            errors.push("Format Type must be 'Video' when Traffic Type is CTV");
        } else if (!isCTV && !VALID_FORMAT_TYPES.includes(normalise(formatRaw))) {
            errors.push("Format Type must be 'Banner', 'Video' or 'Native'");
        }

        // In Banner Video Allow – mandatory only when Format Type is Banner
        const formatIsValid = isCTV ? normalise(formatRaw) === "video" : VALID_FORMAT_TYPES.includes(normalise(formatRaw));
        const isBanner = formatIsValid && normalise(formatRaw) === "banner";
        const inBannerRaw = String(row[OR.inBannerVideo] ?? "").trim();
        if (isBanner) {
            if (inBannerRaw === "") {
                errors.push("In Banner Video Allow is required for Banner format");
            } else if (!["yes", "no"].includes(normalise(inBannerRaw))) {
                errors.push("In Banner Video Allow must be 'Yes' or 'No'");
            }
        } else if (!isBanner && normalise(inBannerRaw) === "yes") {
            errors.push("In Banner Video Allow can only be 'Yes' for Banner format type");
        }

        // Integration Type (mandatory)
        const integrationRaw = String(row[OR.integrationType] ?? "").trim();
        const integrationValue = INTEGRATION_TYPE_MAP_OR[normalise(integrationRaw)];
        if (isMissing(integrationRaw) || integrationRaw === "") {
            errors.push("Integration Type is required");
        } else if (!integrationValue) {
            errors.push(`Integration Type '${integrationRaw}' is not valid`);
        }

        // Zone Name
        if (isMissing(zoneNameRaw) || zoneNameRaw === "") {
            errors.push("Zone Name is required");
        }

        // Is Zone Active (mandatory, True/False)
        const isActiveRaw = String(row[OR.isActive] ?? "").trim();
        if (isActiveRaw === "") {
            errors.push("Is Zone Active is required");
        } else if (!TRUE_FALSE.includes(normalise(isActiveRaw))) {
            errors.push("Is Zone Active must be 'True' or 'False'");
        }

        // Rev Share
        const revShareRaw = String(row[OR.revShare] ?? "").trim();
        if (isMissing(revShareRaw) || revShareRaw === "") {
            errors.push("Rev Share is required");
        } else {
            const rev = parseFloat(revShareRaw);
            if (isNaN(rev) || rev < 0.1 || rev > 100) {
                errors.push("Rev Share must be between 0.1 and 100");
            }
        }

        // Use the highest bid floor (optional – if True, Min eCPM is required)
        const hbfRaw = String(row[OR.highestBidFloor] ?? "").trim();
        const hbfIsTrue = normalise(hbfRaw) === "true";
        if (hbfRaw !== "" && !TRUE_FALSE.includes(normalise(hbfRaw))) {
            errors.push("Use the highest bid floor must be 'True' or 'False'");
        }

        // Min eCPM – mandatory when highest bid floor is True, optional otherwise
        const minEcpmRaw = String(row[OR.minEcpm] ?? "").trim();
        let minEcpmVal = null;
        if (hbfIsTrue && minEcpmRaw === "") {
            errors.push("Min eCPM is required when Use the highest bid floor is True");
        } else if (minEcpmRaw !== "") {
            const val = parseFloat(minEcpmRaw);
            if (isNaN(val) || val < 0.00001 || val > 50) {
                errors.push("Min eCPM must be between 0.00001 and 50");
            } else {
                minEcpmVal = val;
            }
        }

        // Max eCPM (optional)
        const maxEcpmRaw = String(row[OR.maxEcpm] ?? "").trim();
        let maxEcpmVal = null;
        if (maxEcpmRaw !== "") {
            const val = parseFloat(maxEcpmRaw);
            if (isNaN(val) || val < 0.00001 || val > 50) {
                errors.push("Max eCPM must be between 0.00001 and 50");
            } else {
                maxEcpmVal = val;
            }
        }

        // Min ≤ Max
        if (minEcpmVal !== null && maxEcpmVal !== null && minEcpmVal > maxEcpmVal) {
            errors.push("Min eCPM must be less than or equal to Max eCPM");
        }

        // Requests per Day (optional, integer > 0)
        const reqRaw = String(row[OR.requestsPerDay] ?? "").trim();
        if (reqRaw !== "") {
            const val = Number(reqRaw);
            if (!Number.isInteger(val) || val <= 0) {
                errors.push("Requests per Day must be an integer greater than 0");
            }
        }

        // Impressions per Day (optional, integer > 0)
        const impRaw = String(row[OR.impressionsPerDay] ?? "").trim();
        if (impRaw !== "") {
            const val = Number(impRaw);
            if (!Number.isInteger(val) || val <= 0) {
                errors.push("Impressions per Day must be an integer greater than 0");
            }
        }

        // Human IVT Sampling (mandatory, integer 0–100)
        const humanIvtRaw = String(row[OR.humanIvt] ?? "").trim();
        if (humanIvtRaw === "") {
            errors.push("Human IVT Sampling is required");
        } else {
            const val = Number(humanIvtRaw);
            if (!Number.isInteger(val) || val < 0 || val > 100) {
                errors.push("Human IVT Sampling must be an integer between 0 and 100");
            }
        }

        // PIXALATE SUNSET: Pixalate IVT Sampling column removed from upload sheet.
        /*
        // Pixalate IVT Sampling (mandatory, integer 0–100)
        const pixalateIvtRaw = String(row[OR.pixalateIvt] ?? "").trim();
        if (pixalateIvtRaw === "") {
            errors.push("Pixalate IVT Sampling is required");
        } else {
            const val = Number(pixalateIvtRaw);
            if (!Number.isInteger(val) || val < 0 || val > 100) {
                errors.push("Pixalate IVT Sampling must be an integer between 0 and 100");
            }
        }
        */

        // DoubleVerify IVT Sampling (mandatory, integer 0–100)
        const doubleverifyIvtRaw_or = String(row[OR.doubleverifyIvt] ?? "").trim();
        if (doubleverifyIvtRaw_or === "") {
            errors.push("DoubleVerify IVT Sampling is required");
        } else {
            const val = Number(doubleverifyIvtRaw_or);
            if (!Number.isInteger(val) || val < 0 || val > 100) {
                errors.push("DoubleVerify IVT Sampling must be an integer between 0 and 100");
            }
        }

        // Pass Inventory Partner Domain (optional; must be empty or "TRUE")
        const ipdBoolRaw_or = String(row[OR.ipdBool] ?? "").trim();
        if (ipdBoolRaw_or !== "" && normalise(ipdBoolRaw_or) !== "true") {
            errors.push("Pass Inventory Partner Domain must be empty or 'TRUE'");
        }
        const ipdValueRaw_or = String(row[OR.ipdValue] ?? "").trim();

        if (errors.length > 0) {
            return { key: String(idx), row: rowNum, zoneName, status: "error", message: errors, _raw: row, _payload: null };
        }

        // Build payload
        const payload = {
            invent_type: trafficRaw,
            exchange_type: integrationValue,
            traffic_type: formatRaw,
            name: zoneNameRaw,
            is_active: normalise(isActiveRaw) === "true",
            impressions_daily: impRaw !== "" ? parseInt(impRaw, 10) : null,
            requests_daily: reqRaw !== "" ? parseInt(reqRaw, 10) : null,
            publisherId,
            revshare: parseFloat(revShareRaw),
            minEcpm: minEcpmVal,
            maxEcpm: maxEcpmVal,
            isHighestBidFloor: normalise(hbfRaw) === "true",
            bannerCheckbox: isBanner ? normalise(inBannerRaw) === "yes" : null,
            sampling_human: parseInt(humanIvtRaw, 10),
            // PIXALATE SUNSET: not sent in payload
            // sampling_pixalate: parseInt(pixalateIvtRaw, 10),
            sampling_dv: parseInt(doubleverifyIvtRaw_or, 10),
        };
        if (normalise(ipdBoolRaw_or) === "true") payload.ipd_bool = true;
        if (ipdValueRaw_or !== "") payload.ipd_value = ipdValueRaw_or;
        payloads.push(payload);
        return { key: String(idx), row: rowNum, zoneName, status: "valid", message: "Valid", _raw: row, _payload: payload };
    });

    return { results, payloads };
}

// ─── Vast (ADK): validate all rows → { results, payloads } ───────────────────
function validateVastRows(rows, _publisherName, publisherId) {
    // Two-pass duplicate zone name detection
    const zoneNameCount = new Map();
    rows.forEach((row) => {
        const name = String(row[VA.zoneName] ?? "").trim().toLowerCase();
        if (name) zoneNameCount.set(name, (zoneNameCount.get(name) || 0) + 1);
    });
    const duplicateNames = new Set(
        [...zoneNameCount.entries()].filter(([, count]) => count > 1).map(([name]) => name)
    );
    const firstSeenDuplicates = new Set();

    const payloads = [];
    const results = rows.map((row, idx) => {
        const rowNum = idx + 2;
        const zoneNameRaw = String(row[VA.zoneName] ?? "").trim();
        const zoneName = zoneNameRaw || "-";
        const lowerName = zoneNameRaw.toLowerCase();
        const errors = [];

        // Duplicate zone name
        if (lowerName && duplicateNames.has(lowerName)) {
            if (firstSeenDuplicates.has(lowerName)) {
                errors.push("Duplicate zone name");
            } else {
                firstSeenDuplicates.add(lowerName);
            }
        }

        // Traffic Type (mandatory: Website, Inapp, CTV)
        const trafficRaw = String(row[VA.trafficType] ?? "").trim();
        const isCTV = normalise(trafficRaw) === "ctv";
        if (isMissing(trafficRaw) || trafficRaw === "") {
            errors.push("Traffic Type is required");
        } else if (!["website", "inapp", "ctv"].includes(normalise(trafficRaw))) {
            errors.push("Traffic Type must be 'Website', 'Inapp' or 'CTV'");
        }

        // Stream Position (mandatory; CTV must be Instream)
        const streamRaw = String(row[VA.streamPosition] ?? "").trim();
        if (isMissing(streamRaw) || streamRaw === "") {
            errors.push("Stream Position is required");
        } else if (!["instream", "outstream"].includes(normalise(streamRaw))) {
            errors.push("Stream Position must be 'Instream' or 'Outstream'");
        } else if (isCTV && normalise(streamRaw) !== "instream") {
            errors.push("Stream Position must be 'Instream' for CTV traffic type");
        }

        // Zone Name (mandatory)
        if (isMissing(zoneNameRaw) || zoneNameRaw === "") {
            errors.push("Zone Name is required");
        }

        // Is Zone Active? (mandatory, true/false)
        const isActiveRaw = String(row[VA.isActive] ?? "").trim();
        if (isMissing(isActiveRaw) || isActiveRaw === "") {
            errors.push("Is Zone Active? is required");
        } else if (!["true", "false"].includes(normalise(isActiveRaw))) {
            errors.push("Is Zone Active? must be 'true' or 'false'");
        }

        // eCPM (mandatory, >= 0)
        const ecpmRaw = String(row[VA.ecpm] ?? "").trim();
        let ecpmVal = null;
        if (isMissing(ecpmRaw) || ecpmRaw === "") {
            errors.push("eCPM is required");
        } else {
            const val = parseFloat(ecpmRaw);
            if (isNaN(val) || val < 0) {
                errors.push("eCPM must be a number greater than or equal to 0");
            } else {
                ecpmVal = val;
            }
        }

        // Requests per Day (optional, integer >= 0)
        const requestsRaw = String(row[VA.requestsPerDay] ?? "").trim();
        let requestsVal = null;
        if (requestsRaw !== "") {
            const num = Number(requestsRaw);
            if (isNaN(num) || num < 0 || !Number.isInteger(num)) {
                errors.push("Requests per Day must be a non-negative integer");
            } else {
                requestsVal = num;
            }
        }

        // Impressions per Day (optional, integer >= 0)
        const impressionsRaw = String(row[VA.impressionsPerDay] ?? "").trim();
        let impressionsVal = null;
        if (impressionsRaw !== "") {
            const num = Number(impressionsRaw);
            if (isNaN(num) || num < 0 || !Number.isInteger(num)) {
                errors.push("Impressions per Day must be a non-negative integer");
            } else {
                impressionsVal = num;
            }
        }

        // Human IVT Sampling (mandatory, 0–100)
        const humanIvtRaw = String(row[VA.humanIvt] ?? "").trim();
        let humanIvtVal = null;
        if (isMissing(humanIvtRaw) || humanIvtRaw === "") {
            errors.push("Human IVT Sampling is required");
        } else {
            const val = parseFloat(humanIvtRaw);
            if (isNaN(val) || val < 0 || val > 100) {
                errors.push("Human IVT Sampling must be between 0 and 100");
            } else {
                humanIvtVal = val;
            }
        }

        // PIXALATE SUNSET: Pixalate IVT Sampling column removed from upload sheet.
        /*
        // Pixalate IVT Sampling (mandatory, 0–100)
        const pixalateIvtRaw = String(row[VA.pixalateIvt] ?? "").trim();
        let pixalateIvtVal = null;
        if (isMissing(pixalateIvtRaw) || pixalateIvtRaw === "") {
            errors.push("Pixalate IVT Sampling is required");
        } else {
            const val = parseFloat(pixalateIvtRaw);
            if (isNaN(val) || val < 0 || val > 100) {
                errors.push("Pixalate IVT Sampling must be between 0 and 100");
            } else {
                pixalateIvtVal = val;
            }
        }
        */

        // DoubleVerify IVT Sampling (mandatory, 0–100)
        const doubleverifyIvtRaw_va = String(row[VA.doubleverifyIvt] ?? "").trim();
        let doubleverifyIvtVal = null;
        if (isMissing(doubleverifyIvtRaw_va) || doubleverifyIvtRaw_va === "") {
            errors.push("DoubleVerify IVT Sampling is required");
        } else {
            const val = parseFloat(doubleverifyIvtRaw_va);
            if (isNaN(val) || val < 0 || val > 100) {
                errors.push("DoubleVerify IVT Sampling must be between 0 and 100");
            } else {
                doubleverifyIvtVal = val;
            }
        }

        // Pass Inventory Partner Domain (optional; must be empty or "TRUE")
        const ipdBoolRaw_va = String(row[VA.ipdBool] ?? "").trim();
        if (ipdBoolRaw_va !== "" && normalise(ipdBoolRaw_va) !== "true") {
            errors.push("Pass Inventory Partner Domain must be empty or 'TRUE'");
        }
        const ipdValueRaw_va = String(row[VA.ipdValue] ?? "").trim();

        // Template (mandatory)
        const templateRaw_va = String(row[VA.template] ?? "").trim();
        if (isMissing(templateRaw_va) || templateRaw_va === "") {
            errors.push("Template is required");
        }

        if (errors.length > 0) {
            return { key: String(idx), row: rowNum, zoneName, status: "error", message: errors, _raw: row, _payload: null };
        }

        const payload = {
            invent_type: trafficRaw,
            stream_position: streamRaw,
            name: zoneNameRaw,
            is_active: normalise(isActiveRaw) === "true",
            publisherId,
            revenue_type: "Fixed_Price",
            fixed_cpm: ecpmVal,
            requests_daily: requestsVal,
            impressions_daily: impressionsVal,
            sampling_human: humanIvtVal,
            // PIXALATE SUNSET: not sent in payload
            // sampling_pixalate: pixalateIvtVal,
            sampling_dv: doubleverifyIvtVal,
            template: templateRaw_va,
        };
        if (normalise(ipdBoolRaw_va) === "true") payload.ipd_bool = true;
        if (ipdValueRaw_va !== "") payload.ipd_value = ipdValueRaw_va;
        payloads.push(payload);
        return { key: String(idx), row: rowNum, zoneName, status: "valid", message: "Valid", _raw: row, _payload: payload };
    });

    return { results, payloads };
}

// ─── Publica: validate all rows → { results, payloads } ──────────────────────
const REGION_MAP_PC = {
    "apac": "ap-southeast-2",
    "europe": "eu-west-1",
    "japan": "ap-northeast-1",
    "usa": "us-east-1",
};

function validatePublicaRows(rows, _publisherName, publisherId, publisherList = []) {
    const publisherEntry = publisherList.find((p) => p.value === publisherId);
    const isDirect = publisherEntry?.isDirect ?? false;
    // Two-pass duplicate channel name detection
    const channelNameCount = new Map();
    rows.forEach((row) => {
        const name = String(row[PC.channelName] ?? "").trim().toLowerCase();
        if (name) channelNameCount.set(name, (channelNameCount.get(name) || 0) + 1);
    });
    const duplicateNames = new Set(
        [...channelNameCount.entries()].filter(([, count]) => count > 1).map(([name]) => name)
    );
    const firstSeenDuplicates = new Set();

    const payloads = [];
    const results = rows.map((row, idx) => {
        const rowNum = idx + 2;
        const channelNameRaw = String(row[PC.channelName] ?? "").trim();
        const zoneName = channelNameRaw || "-";
        const lowerName = channelNameRaw.toLowerCase();
        const errors = [];

        // Duplicate channel name
        if (lowerName && duplicateNames.has(lowerName)) {
            if (firstSeenDuplicates.has(lowerName)) {
                errors.push("Duplicate channel name");
            } else {
                firstSeenDuplicates.add(lowerName);
            }
        }

        // Traffic Type (mandatory: Website, Inapp, CTV)
        const trafficRaw = String(row[PC.trafficType] ?? "").trim();
        if (isMissing(trafficRaw) || trafficRaw === "") {
            errors.push("Traffic Type is required");
        } else if (!["website", "inapp", "ctv"].includes(normalise(trafficRaw))) {
            errors.push("Traffic Type must be 'Website', 'Inapp' or 'CTV'");
        }

        // Format Type (mandatory, always Video for Publica)
        const formatRaw = String(row[PC.formatType] ?? "").trim();
        if (isMissing(formatRaw) || formatRaw === "") {
            errors.push("Format Type is required");
        } else if (normalise(formatRaw) !== "video") {
            errors.push("Format Type must be 'Video' for Vast Publica");
        }

        // Channel Name
        if (isMissing(channelNameRaw) || channelNameRaw === "") {
            errors.push("Channel Name is required");
        }

        // Region (mandatory: APAC, Europe, Japan, USA)
        const regionRaw = String(row[PC.region] ?? "").trim();
        if (isMissing(regionRaw) || regionRaw === "") {
            errors.push("Region is required");
        } else if (!["apac", "europe", "japan", "usa"].includes(normalise(regionRaw))) {
            errors.push("Region must be 'APAC', 'Europe', 'Japan' or 'USA'");
        }

        // eCPM (mandatory, >= 0)
        const ecpmRaw = String(row[PC.ecpm] ?? "").trim();
        let ecpmVal = null;
        if (isMissing(ecpmRaw) || ecpmRaw === "") {
            errors.push("eCPM is required");
        } else {
            const val = parseFloat(ecpmRaw);
            if (isNaN(val) || val < 0) {
                errors.push("eCPM must be a number greater than or equal to 0");
            } else {
                ecpmVal = val;
            }
        }

        // Bid Adjustment (mandatory, 0–100)
        const bidAdjRaw = String(row[PC.bidAdjustment] ?? "").trim();
        let bidAdjVal = null;
        if (isMissing(bidAdjRaw) || bidAdjRaw === "") {
            errors.push("Bid Adjustment is required");
        } else {
            const val = parseFloat(bidAdjRaw);
            if (isNaN(val) || val < 0 || val > 100) {
                errors.push("Bid Adjustment must be between 0 and 100");
            } else {
                bidAdjVal = val;
            }
        }

        // Bid Adjustment Value (optional, >= 0)
        const bidAdjValueRaw = String(row[PC.bidAdjustmentValue] ?? "").trim();
        let bidAdjValue = null;
        if (bidAdjValueRaw !== "") {
            const val = parseFloat(bidAdjValueRaw);
            if (isNaN(val) || val < 0) {
                errors.push("Bid Adjustment Value must be a number greater than or equal to 0");
            } else {
                bidAdjValue = val;
            }
        }

        // ASI (mandatory)
        // const asiRaw = String(row[PC.asi] ?? "").trim();
        // if (isMissing(asiRaw) || asiRaw === "") {
        //     errors.push("ASI is required");
        // }

        // // SID (Publisher ID) – mandatory, must match the numeric prefix of the selected publisher
        // const sidRaw = String(row[PC.sid] ?? "").trim();
        // const expectedSid = String(publisherId ?? "").split("-")[0].trim();
        // if (isMissing(sidRaw) || sidRaw === "") {
        //     errors.push("SID (Publisher ID) is required");
        // } else if (expectedSid && sidRaw !== expectedSid) {
        //     errors.push(`SID (Publisher ID) must be '${expectedSid}' for the selected publisher`);
        // }

        // // Name (mandatory)
        // const nameRaw = String(row[PC.name] ?? "").trim();
        // if (isMissing(nameRaw) || nameRaw === "") {
        //     errors.push("Name is required");
        // }

        // // Domain (mandatory)
        // const domainRaw = String(row[PC.domain] ?? "").trim();
        // if (isMissing(domainRaw) || domainRaw === "") {
        //     errors.push("Domain is required");
        // }

        // Template (mandatory)
        const templateRaw = String(row[PC.template] ?? "").trim();
        if (isMissing(templateRaw) || templateRaw === "") {
            errors.push("Template is required");
        }

        // Header Bidder Vast Version (mandatory: 2, 3, 4, 4.1)
        const vastVersionRaw = String(row[PC.headerBidderVastVersion] ?? "").trim();
        if (isMissing(vastVersionRaw) || vastVersionRaw === "") {
            errors.push("Header Bidder Vast Version is required");
        } else if (!["2", "3", "4", "4.1"].includes(vastVersionRaw)) {
            errors.push("Header Bidder Vast Version must be '2', '3', '4' or '4.1'");
        }

        // Optional fields
        const addValueRaw = String(row[PC.addValueIfEmpty] ?? "").trim();
        const overrideRaw = String(row[PC.override] ?? "").trim();

        if (errors.length > 0) {
            return { key: String(idx), row: rowNum, zoneName, status: "error", message: errors, _raw: row, _payload: null };
        }

        // Build payload
        const payload = {
            invent_type: trafficRaw,
            format_type: formatRaw,
            header_bidder_vast_version: vastVersionRaw || null,
            channel_name: channelNameRaw,
            region: REGION_MAP_PC[normalise(regionRaw)] ?? regionRaw,
            eCpm: ecpmVal,
            bid_adjustment: bidAdjVal,
            bid_adjustment_value: bidAdjValue,
            // asi: asiRaw,
            // sid: sidRaw,
            // name: nameRaw,
            // domain: domainRaw,
            template: templateRaw,
            isAddValueCheckbox: normalise(addValueRaw) === "true" ? true : false,
            override: overrideRaw || "",
            publisherId,
            sampling_pixalate: 25,
            sampling_human: isDirect ? 50 : 0,
            sampling_doubleverify: 0,
        };
        payloads.push(payload);
        return { key: String(idx), row: rowNum, zoneName, status: "valid", message: "Valid", _raw: row, _payload: payload };
    });

    return { results, payloads };
}

// ─── Zone type dispatcher map ─────────────────────────────────────────────────
const ZONE_VALIDATORS = {
    "Prebid": validatePrebidRows,
    "Open RTB": validateOpenRTBRows,
    "Vast Zone": validateVastRows,
    "publica": validatePublicaRows,
};

// ─── SVG icons ────────────────────────────────────────────────────────────────

const ValidIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14.5341 6.66666C14.8385 8.16086 14.6215 9.71428 13.9193 11.0679C13.2171 12.4214 12.072 13.4934 10.6751 14.1049C9.27816 14.7164 7.71382 14.8305 6.24293 14.4282C4.77205 14.026 3.48353 13.1316 2.59225 11.8943C1.70097 10.657 1.26081 9.15148 1.34518 7.62892C1.42954 6.10635 2.03332 4.65872 3.05583 3.52744C4.07835 2.39616 5.45779 1.64961 6.96411 1.4123C8.47043 1.17498 10.0126 1.46123 11.3334 2.22333" stroke="#00A63E" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 7.33317L8 9.33317L14.6667 2.6665" stroke="#00A63E" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z" stroke="#E7000B" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 6L6 10" stroke="#E7000B" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 6L10 10" stroke="#E7000B" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// eslint-disable-next-line no-unused-vars
const DownloadSmIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#020617" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.08423 5.8335L7.0009 8.75016L9.91756 5.8335" stroke="#020617" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 8.75V1.75" stroke="#020617" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// eslint-disable-next-line no-unused-vars
const DownloadGrayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#64748B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.66748 6.6665L8.00081 9.99984L11.3341 6.6665" stroke="#64748B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 10V2" stroke="#64748B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// ─── Table columns ─────────────────────────────────────────────────────────────

const getTableColumns = (zoneType) => [
    { title: 'Row', dataIndex: 'row', key: 'row', width: 80 },
    { title: zoneType === 'publica' ? 'Channel Name' : 'Zone Name', dataIndex: 'zoneName', key: 'zoneName' },
    {
        title: 'Status', dataIndex: 'status', key: 'status', width: 120,
        render: (status) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                {status === 'valid'
                    ? <><ValidIcon /><span style={{ color: '#00A63E' }}>Valid</span></>
                    : <><ErrorIcon /><span style={{ color: '#E7000B' }}>Error</span></>
                }
            </div>
        ),
    },
    {
        title: 'Message', dataIndex: 'message', key: 'message',
        render: (message) => {
            if (!message) return null;
            const lines = Array.isArray(message) ? message : [message];
            return (
                <div>
                    {lines.map((line, i) => (
                        <div key={i}>{line}</div>
                    ))}
                </div>
            );
        },
    },
];

// ─── Component ────────────────────────────────────────────────────────────────

const BulkZoneCreate = ({ handlePageViewChange }) => {

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    });

    const [publisherList, setPublisherList] = useState([]);
    const [selectedPublisher, setSelectedPublisher] = useState("");
    const [publisherError, setPublisherError] = useState(false);

    const [zoneType, setZoneType] = useState("");
    const [zoneTypeError, setZoneTypeError] = useState(false);

    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [uploadedFileSize, setUploadedFileSize] = useState(0);
    // Each entry: { key, row, zoneName, status, message, _raw, _payload }
    const [validationResults, setValidationResults] = useState([]);
    // Only valid rows' payload objects
    const [validPayloads, setValidPayloads] = useState([]);
    // Original template columns from uploaded file (for download)
    const [originalColumns, setOriginalColumns] = useState([]);

    const [blockCategorySelected, setBlockCategorySelected] = useState(new Set());
    const [blockCategorySelectedTrack, setBlockCategorySelectedTrack] = useState(new Set());
    const [blockCategoryNormalizeKey, setBlockCategoryNormalizeKey] = useState(0);
    const [buttonProcessing, setButtonProcessing] = useState(false);
    const fileInputRef = useRef(null);

    // ── Load publisher list ────────────────────────────────────────────────────
    useEffect(() => {
        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;
        axios
            .get(configData.SERVER_URL + "zone/pubMinifiedList", {
                headers: { "Content-Type": "application/json", "x-access-token": token },
            })
            .then((res) => setPublisherList(res.data.data || []))
            .catch(() => { });
    }, []);

    // ── Publisher change ───────────────────────────────────────────────────────
    const handlePublisherChange = (value) => {
        setSelectedPublisher(value);
        setPublisherError(false);

        const selectedPublisher = publisherList?.find(
            (publisher) => publisher.value === value
        );
        setBlockCategorySelected(new Set(selectedPublisher?.block_cat) || new Set())
        setBlockCategorySelectedTrack(new Set(selectedPublisher?.block_cat) || new Set())
        setBlockCategoryNormalizeKey(k => k + 1)
    };

    // ── Zone type change – clears all upload state ─────────────────────────────
    const handleZoneTypeChange = (value) => {
        setZoneType(value);
        setZoneTypeError(false);
        clearUpload();
        setBlockCategorySelected(blockCategorySelectedTrack)
        setBlockCategoryNormalizeKey(k => k + 1)
    };

    const clearUpload = () => {
        setUploadedFile(null);
        setUploadedFileName("");
        setUploadedFileSize(0);
        setValidationResults([]);
        setValidPayloads([]);
        setOriginalColumns([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    // ── Publisher display name (for zone name construction) ───────────────────
    const publisherName = selectedPublisher
        ? selectedPublisher.split("-").slice(1).join("-")
        : "";

    // ── Download template ──────────────────────────────────────────────────────
    // const downloadTemplate = () => {
    //     if (!zoneType) return;
    //     const cfg = ZONE_CONFIG[zoneType];
    //     const ws = XLSX.utils.aoa_to_sheet([cfg.templateColumns]);
    //     ws['!cols'] = cfg.templateColumns.map((col) => ({ wch: Math.max(col.length + 4, 16) }));
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Template");
    //     XLSX.writeFile(wb, `${cfg.displayName}_template.xlsx`);
    // };


    const handleDownload = async (type) => {
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");

        if (type === "Prebid") {
            type = "prebid"
        }
        else if (type === "Open RTB") {
            type = "openrtb"
        }
        else if (type === "Vast Zone") {
            type = "vastadk"
        }


        axios
            .get(
                configData.SERVER_URL +
                `zone/download/sample?type=` + type?.toLowerCase(),
                {
                    headers: {
                        "Content-Type": "application/json",
                        // "x-access-token": token,
                    },
                    responseType: "blob",
                }
            )
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                // saveAs(blob, type + "_" + new Date().getTime() + ".xlsx");
                saveAs(blob, type + "_sample.xlsx");
            })
            .catch((error) => { });

    };

    // ── File handlers ──────────────────────────────────────────────────────────
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) processFile(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) processFile(file);
    };

    const processFile = (file) => {
        if (zoneType === "publica" && !selectedPublisher) {
            notifyfailure("Please select a publisher before uploading the file.");
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
        }
        const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (!['.xlsx', '.xls'].includes(ext)) {
            notifyfailure("Only Excel files (.xlsx, .xls) are allowed.");
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onload = (ev) => {
            try {
                const data = new Uint8Array(ev.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

                if (jsonData.length === 0) {
                    notifyfailure("The file contains no data.");
                    if (fileInputRef.current) fileInputRef.current.value = "";
                    return;
                }

                // Validate that all required template headers are present (fuzzy: ignore * spacing)
                const fileHeaders = Object.keys(jsonData[0]);
                const normFileHeaders = fileHeaders.map(normaliseHeader);
                const requiredHeaders = ZONE_CONFIG[zoneType]?.templateColumns || [];
                const missingHeaders = requiredHeaders.filter(
                    (h) => !normFileHeaders.includes(normaliseHeader(h))
                );
                if (missingHeaders.length > 0) {
                    notifyfailure(`Invalid file format. Missing columns: ${missingHeaders.join(', ')}`);
                    if (fileInputRef.current) fileInputRef.current.value = "";
                    return;
                }

                // Remap file row keys to canonical template column names (fuzzy match)
                const headerRemap = {};
                fileHeaders.forEach((fh) => {
                    const match = requiredHeaders.find(
                        (rh) => normaliseHeader(rh) === normaliseHeader(fh)
                    );
                    if (match) headerRemap[fh] = match;
                });
                const remappedData = jsonData.map((row) => {
                    const newRow = {};
                    Object.keys(row).forEach((k) => {
                        newRow[headerRemap[k] || k] = row[k];
                    });
                    return newRow;
                });

                // Filter out completely empty rows (from remapped data)
                const nonEmpty = remappedData.filter((row) =>
                    Object.values(row).some((v) => String(v).trim() !== "")
                );

                if (nonEmpty.length === 0) {
                    notifyfailure("The file contains no data. Please add at least one row.");
                    if (fileInputRef.current) fileInputRef.current.value = "";
                    return;
                }

                if (nonEmpty.length > 500) {
                    notifyfailure(`File contains ${nonEmpty.length} rows. Maximum allowed is 500 rows.`);
                    if (fileInputRef.current) fileInputRef.current.value = "";
                    return;
                }

                setUploadedFile(file);
                setUploadedFileName(file.name);
                setUploadedFileSize(file.size);
                setOriginalColumns(fileHeaders); // keep original headers for download report
                validateRows(nonEmpty);
            } catch {
                notifyfailure("Failed to parse file. Please check the format.");
                if (fileInputRef.current) fileInputRef.current.value = "";
            }
        };
        reader.readAsArrayBuffer(file);
    };

    // ── Row validation ─────────────────────────────────────────────────────────
    const validateRows = (rows) => {
        if (!zoneType) return;
        const handler = ZONE_VALIDATORS[zoneType];
        if (!handler) return;
        const { results, payloads } = handler(rows, publisherName, selectedPublisher, publisherList);
        setValidationResults(results);
        setValidPayloads(payloads.filter(Boolean));
    };

    // ── Download: original file + Status + Error Message columns ──────────────
    // eslint-disable-next-line no-unused-vars
    const downloadValidationReport = () => {
        if (!validationResults.length) return;

        const requiredHeaders = ZONE_CONFIG[zoneType]?.templateColumns || [];
        // Build map: original file header → canonical key (for reading _raw which has canonical keys)
        const origToCanonical = {};
        originalColumns.forEach((orig) => {
            const match = requiredHeaders.find(
                (rh) => normaliseHeader(rh) === normaliseHeader(orig)
            );
            origToCanonical[orig] = match || orig;
        });

        const cols = originalColumns.length > 0 ? originalColumns : Object.keys(validationResults[0]._raw || {});
        const headerRow = [...cols, "Status", "Error Message"];

        const dataRows = validationResults.map((r) => {
            const rawValues = cols.map((col) => {
                const canonicalKey = origToCanonical[col] || col;
                return r._raw ? (r._raw[canonicalKey] ?? r._raw[col] ?? "") : "";
            });
            return [
                ...rawValues,
                r.status === "valid" ? "Valid" : "Invalid",
                r.status === "valid" ? "" : (Array.isArray(r.message) ? r.message.join('; ') : r.message),
            ];
        });

        const ws = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
        // Column widths
        ws['!cols'] = headerRow.map((h) => ({ wch: Math.max(String(h).length + 4, 16) }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Validation Report");
        const baseName = uploadedFileName.replace(/\.[^.]+$/, "");
        XLSX.writeFile(wb, `${baseName}_validation_report.xlsx`);
    };

    // ── Create zones ───────────────────────────────────────────────────────────
    const handleCreate = () => {
        let hasError = false;
        if (!selectedPublisher) { setPublisherError(true); hasError = true; }
        if (!zoneType) { setZoneTypeError(true); hasError = true; }
        if (hasError) return;

        if (!uploadedFile || validPayloads.length === 0) {
            notifyfailure("Please upload a file with at least one valid zone.");
            return;
        }

        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;

        setButtonProcessing(true);

        if (zoneType === "Prebid" || zoneType === "Open RTB" || zoneType === "publica" || zoneType === "Vast Zone") {
            axios
                .post(
                    configData.SERVER_URL + "zone/createBulkPrebidZone",
                    { publisherId: selectedPublisher, zoneType, zones: validPayloads, blockCategory: [...blockCategorySelected] },
                    { headers: { "Content-Type": "application/json", "x-access-token": token } }
                )
                .then(() => {
                    notifysuccess(`${validPayloads.length} zone(s) created successfully.`);
                    handlePageViewChange("table", "yes");
                })
                .catch((error) => {
                    if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message)
                    }
                    else {
                        notifyfailure("Failed to create zones. Please try again.")
                    }
                })
                .finally(() => setButtonProcessing(false));
        }
    };

    // ── Derived ────────────────────────────────────────────────────────────────
    const validCount = validationResults.filter((r) => r.status === "valid").length;
    const errorCount = validationResults.filter((r) => r.status === "error").length;
    const hasErrors = errorCount > 0;
    const cfg = zoneType ? ZONE_CONFIG[zoneType] : null;

    // ─────────────────────────────────────────────────────────────────────────
    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => handlePageViewChange("table", "no")}>
                                <img src={zoneIcon} alt="Zones" /> Zones
                            </Link>
                        </li>
                        <li className="primary">Create Multiple Zones</li>
                    </ul>
                </div>

                <div className="container_box--wrapper--title d_flex justify-content-between align-items-center">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => handlePageViewChange("table", "no")} />
                        <h1 className="heading">Create Multiple Zones</h1>
                    </div>
                </div>

                <div className="container_box--content pt_20 form_scrollable_div_d2">
                    <div className="container_box--width">

                        {/* Publisher */}
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Publisher</label>
                                    <p className='sub_text'>Choose Publisher account</p>
                                </div>
                            </Col>
                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">Publisher *</label>
                                                <Select
                                                    showSearch={true}
                                                    className={`form_select basic basic_two no_search ${publisherError ? ' error_border' : ''}`}
                                                    placeholder="Select publisher"
                                                    optionFilterProp="label"
                                                    value={selectedPublisher || undefined}
                                                    // open={true}
                                                    onChange={handlePublisherChange}
                                                    options={publisherList}
                                                // disabled={zoneType === "publica" && uploadedFile}
                                                />
                                                <span className="error_content">
                                                    {publisherError ? "Publisher is required" : " "}
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        {/* Zone Type */}
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Zone Type</label>
                                    <p className='sub_text'>Choose your zone type.</p>
                                </div>
                            </Col>
                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Zone Type *</label>
                                                <Select
                                                    showSearch
                                                    className={`form_select basic no_search${zoneTypeError ? ' error_border' : ''}`}
                                                    placeholder="Select zone type"
                                                    optionFilterProp="label"
                                                    value={zoneType || undefined}
                                                    onChange={handleZoneTypeChange}
                                                    options={ZONE_TYPES}
                                                />
                                                <span className="error_content">
                                                    {zoneTypeError ? "Zone type is required" : " "}
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        {/* Sensitive Categories */}
                        {["Prebid", "Open RTB", "Vast Zone"].includes(zoneType) && (
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Please select all sensitive categories you would like us to block on your supply.</label>
                                        {/* <p className='sub_text'>Block sensitive categories on your supply.</p> */}
                                    </div>
                                </Col>
                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb-0">
                                                    {/* <label className="form_label">Please select all sensitive categories you would like us to block on your supply.</label> */}
                                                    <BlockCategoryTable
                                                        selected={blockCategorySelected}
                                                        setSelected={setBlockCategorySelected}
                                                        normalizeKey={blockCategoryNormalizeKey}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        )}

                        {/* Upload */}
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Upload Custom Configuration</label>
                                </div>
                            </Col>
                            <Col span={16}>
                                <div className="container_box--form-container">
                                    {!zoneType ? (
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb-0">
                                                    <p className="sub_text" style={{ paddingTop: 8 }}>
                                                        Please select a zone type to see the upload configuration.
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row gutter={16}>
                                            <Col span={24}>

                                                {/* Download template card */}
                                                <div className='form_content_block--group'>
                                                    <div className='download_template_div'>
                                                        <img src={TooltipIcon} className='img-fluid' alt="" />
                                                        <div className='download_template_text'>
                                                            <h4>Download Template</h4>
                                                            <p>{cfg.description}</p>
                                                            <div className='export_btn_hover_d2'>
                                                                <Button
                                                                    className='export_btn_d2'
                                                                    onClick={() => { handleDownload(zoneType) }}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <g clip-path="url(#clip0_12773_7755)">
                                                                            <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#020617" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M4.08423 5.8335L7.0009 8.75016L9.91756 5.8335" stroke="#020617" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M7 8.75V1.75" stroke="#020617" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_12773_7755">
                                                                                <rect width="14" height="14" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                    Download Template
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Mandatory fields */}
                                                    <div className='mandatory_configuration_fields_div'>
                                                        <h4>Mandatory configuration fields</h4>
                                                        {cfg.mandatoryUiCols.length > 1 ? (
                                                            <div className='d-flex align-items-start gap_80'>
                                                                {cfg.mandatoryUiCols.map((col, ci) => (
                                                                    <ul key={ci}>{col.map((f) => <li key={f}>{f}</li>)}</ul>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <ul>{cfg.mandatoryUiCols[0].map((f) => <li key={f}>{f}</li>)}</ul>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* File upload */}
                                                <div className="form_content_block--group mb-0">
                                                    <label className="form_label">Upload File *</label>

                                                    {!uploadedFile && (
                                                        <label
                                                            htmlFor='bulkZoneFileUploader'
                                                            className='ant_upload_drag'
                                                            onDragOver={(e) => e.preventDefault()}
                                                            onDrop={handleDrop}
                                                        >
                                                            <p className="upload_drag_icon">
                                                                <img src={uploadIcon} alt='Upload' />
                                                            </p>
                                                            <p className="ant_upload_text">
                                                                <b className="primary">Click to upload</b> or drag and drop
                                                            </p>
                                                            <p className="ant_upload_hint">
                                                                Excel files (.xlsx, .xls) - Max 500 rows
                                                            </p>
                                                        </label>
                                                    )}

                                                    <input
                                                        ref={fileInputRef}
                                                        className='form_upload d-none'
                                                        type="file"
                                                        id="bulkZoneFileUploader"
                                                        accept=".xlsx,.xls"
                                                        onChange={handleFileChange}
                                                    />

                                                    {/* Uploaded file item */}
                                                    {uploadedFile && (
                                                        <div className="ant_upload_list--item">
                                                            <div className="ant_upload_list--content">
                                                                <img src={CSVIcon} alt="File" />
                                                                <div className="ant_upload_list--info">
                                                                    <span className="ant_upload_list--info-name">{uploadedFileName}</span>
                                                                    <span className="ant_upload_list--info-size">{formatFileSize(uploadedFileSize)}</span>
                                                                </div>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="ant_upload_list--delete"
                                                                onClick={clearUpload}
                                                            >
                                                                <img src={deleteIcon} alt="Remove" />
                                                            </button>
                                                        </div>
                                                    )}

                                                    {/* Validation results */}
                                                    {validationResults.length > 0 && (
                                                        <div className='table_alert_download_div'>
                                                            <div className='btn_valid_error_div'>
                                                                <button
                                                                    type="button"
                                                                // onClick={downloadValidationReport}
                                                                >
                                                                    Validation Results
                                                                    {/* <DownloadGrayIcon /> */}
                                                                </button>
                                                                <div className='valid_errors_text'>
                                                                    <p className='--green'>
                                                                        <ValidIcon />
                                                                        {validCount} Valid
                                                                    </p>
                                                                    {hasErrors && (
                                                                        <p className='--red'>
                                                                            <ErrorIcon />
                                                                            {errorCount} {errorCount === 1 ? 'Error' : 'Errors'}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {hasErrors && (
                                                                <div className='error_div'>
                                                                    <div className="alert_yellow_div">
                                                                        <span>
                                                                            Errors found in upload. You can continue with valid configurations only, or fix the errors and re-upload your data.
                                                                            {/* or download the error log to fix and re-upload your data. */}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className='table_content--box --new_layout_table_design'>
                                                                <Table
                                                                    pagination={false}
                                                                    dataSource={validationResults}
                                                                    columns={getTableColumns(zoneType)}
                                                                    // scroll={{ x: "max-content" }}
                                                                    scroll={{ y: 'calc(100vh - 58.6rem' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Col>
                        </Row>

                    </div>

                    <div className="hr_custom mb_20"></div>

                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button
                            type="button"
                            className="w_120_d2 btn btn_white_outline w_fit_content"
                            onClick={() => handlePageViewChange("table", "no")}
                        >
                            Discard
                        </button>
                        <button
                            type="button"
                            className={`w_120_d2 btn btn_primary w_fit_content${buttonProcessing ? '' : ''}`}
                            onClick={handleCreate}
                            disabled={buttonProcessing || validCount === 0}
                        >
                            {buttonProcessing
                                ? <span>Processing...</span>
                                : <span>Create {validCount} Zone{validCount !== 1 ? 's' : ''}</span>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BulkZoneCreate;
